import React from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
import Footer from "../Component/Footer";
import { useState, useEffect } from "react";
import LazyLoad from "react-lazyload";
const API_URL = "https://webapi.entab.info";
const Vacancy = () => {
  const [vacancyData, setVacancyData] = useState("");

  useEffect(() => {
    async function getVacancyDetail() {
      const res = await fetch(API_URL + `/api/circular/all/PCSD`);
      const data = await res.json();

      // Fix: clean category and filter properly
      const filtered = data.filter(
        (item) => item.category?.trim() === "Vacancy",
      );

      // Optional: sort by date newest first
      const sorted = filtered.sort(
        (a, b) => new Date(b.date) - new Date(a.date),
      );

      setVacancyData(sorted);
    }

    getVacancyDetail();
  }, []);

  useEffect(() => {
    // Set the page title
    document.title = "Vacancy - Presentation Convent School Delhi";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
          </li>
          <li> School </li>
          <li>Vacancy</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Vacancy</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-7 tcsec">
              {vacancyData &&
                vacancyData.sort(function(a,b){
                  return b-a
                }).map((item, index) => (
                  <p key={index}>
                    {/* Title */}
                    {item.title}

                    {/* Attachments */}
                    {item.attachments && item.attachments.length > 0 && (
                      <span>
                        -
                        <a
                         href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Attachment
                        </a>
                      </span>
                    )}

                    {/* URL if provided */}
                    {item.url && (
                      <span>
                        -
                        <a
                          href={item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View More
                        </a>
                      </span>
                    )}
                  </p>
                ))}
            </div>

            {/* <div className="col-12 text-left">
              <ul>
                <li>
                  <b>TGT Mathematics (Graduation/Post Graduation + B.Ed)</b>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Vacancy;
